import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, useEffect, useRef, useState } from "react";
const options = {
    day: {
        placeholder: "dd",
        regex: `^[0-9]{2}`,
    },
    month: {
        placeholder: "mm",
        regex: `^[0-9]{2}`,
    },
    year: {
        placeholder: "yyyy",
        regex: `^[0-9]{4}`,
    },
};
export const DatePartInput = forwardRef(({ value, setValue, setDate, values, required, disabled, autoFocus, min = 1, max, part, previousInput, nextInput, setFocus, }, ref) => {
    const [isInvalid, setIsInvalid] = useState(false);
    const inputRef = useRef(null);
    useEffect(() => {
        if (part === "year" && value.length !== 4) {
            setIsInvalid(true);
        }
        else if (+value > max || +value < min) {
            setIsInvalid(true);
        }
        else if (isInvalid) {
            setIsInvalid(false);
        }
    }, [part, min, max, value, isInvalid]);
    const regexTest = `^[0-9]{0,${max.toString().length}}$`;
    const setValueHandler = (newValue) => {
        if (!newValue) {
            setValue("");
        }
        else if (new RegExp(regexTest).test(newValue)) {
            setValue(newValue);
            const year = part === "year" ? newValue : values.year;
            const month = part === "month" ? newValue : values.month;
            const day = part === "day" ? newValue : values.day;
            if (day && month && year.length === 4) {
                setDate(`${year}-${month.length === 2 ? month : `0${month}`}-${day.length === 2 ? day : `0${day}`}`);
            }
        }
    };
    return (_jsx("input", { ref: ref || inputRef, value: value || "", onChange: (e) => setValueHandler(e.target.value), onClick: (e) => e.stopPropagation(), onKeyDown: (e) => {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                previousInput === null || previousInput === void 0 ? void 0 : previousInput.select();
            }
            else if (e.key === "ArrowRight") {
                e.preventDefault();
                nextInput === null || nextInput === void 0 ? void 0 : nextInput.select();
            }
        }, onKeyUp: (e) => {
            if (part !== "year" && isFinite(+e.key) && value.length === 2) {
                nextInput === null || nextInput === void 0 ? void 0 : nextInput.select();
            }
        }, onFocus: (e) => {
            setFocus(true);
            e.target.select();
        }, onBlur: () => setFocus(false), required: required, disabled: disabled, autoFocus: autoFocus, min: min, max: max, inputMode: "numeric", type: "number", tabIndex: part !== "day" ? -1 : undefined, placeholder: options[part].placeholder, pattern: options[part].regex, className: clsx({ error: isInvalid }), style: {
            width: part === "year" && !value
                ? "4ch"
                : part === "month" && !value
                    ? 23
                    : `${value.length || 2}ch`,
        } }));
});
